import { Box, Skeleton } from "@mui/material";
import { PenLine, Square } from "lucide-react";
import "./TableSkeleton.scss";

interface TableSkeletonProps {
  mode?: string;
}

export default function TableSkeleton({ mode }: TableSkeletonProps) {
  const renderSkeleton = () => {
    switch (mode) {
      case "checkbox":
        return (
          <Box>
            {Array.from({ length: 9 }).map((_, index) => (
              <Box key={index} className="menu-view">
                <Square className="menu-view__icon" />
                <Skeleton
                  className="menu-view__skeleton"
                  height={20}
                  variant="text"
                  animation="wave"
                />
                <PenLine className="menu-view__icon--end" />
              </Box>
            ))}
          </Box>
        );
      case "ideas":
        return (
          <Box>
            {Array.from({ length: 3 }).map((_, index) => (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  paddingRight: "40px",
                }}
              >
                <Skeleton
                  width={500}
                  height={50}
                  variant="text"
                  sx={{ fontSize: "1rem" }}
                  animation="wave"
                />
                <Skeleton
                  width={200}
                  animation="wave"
                  variant="text"
                  sx={{ fontSize: "1rem" }}
                />
                <Skeleton
                  width={200}
                  animation="wave"
                  variant="text"
                  sx={{ fontSize: "1rem" }}
                />
                <Skeleton
                  width={200}
                  animation="wave"
                  variant="text"
                  sx={{ fontSize: "1rem" }}
                />
                <Skeleton
                  width={200}
                  animation="wave"
                  variant="text"
                  sx={{ fontSize: "1rem" }}
                />
              </Box>
            ))}
          </Box>
        );
      case "history":
        return (
          <Box>
            {Array.from({ length: 3 }).map((_, index) => (
              <Box
                className="history"
                sx={{
                  display: "flex",
                  paddingRight: "40px",
                }}
              >
                <Skeleton
                  className="history__skeletons--first"
                  variant="text"
                  animation="wave"
                />
                <Skeleton
                  className="history__skeletons"
                  animation="wave"
                  variant="text"
                />
                <Skeleton
                  className="history__skeletons"
                  animation="wave"
                  variant="text"
                  sx={{ marginRight: "30px !important" }}
                />
                <Skeleton
                  className="history__skeletons"
                  animation="wave"
                  variant="text"
                />
                <Skeleton
                  className="history__skeletons--last"
                  animation="wave"
                  variant="text"
                />
              </Box>
            ))}
          </Box>
        );
    }
  };
  return <>{renderSkeleton()}</>;
}
